"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInputMobile = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _server = _interopRequireDefault(require("react-dom/server"));
var SearchIcon = function SearchIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M505.749 475.587l-145.6-145.6c28.203-34.837 45.184-79.104 45.184-127.317C405.333 90.926 314.41.003 202.666.003S0 90.925 0 202.669s90.923 202.667 202.667 202.667c48.213 0 92.48-16.981 127.317-45.184l145.6 145.6c4.16 4.16 9.621 6.251 15.083 6.251s10.923-2.091 15.083-6.251c8.341-8.341 8.341-21.824-.001-30.165zM202.667 362.669c-88.235 0-160-71.765-160-160s71.765-160 160-160 160 71.765 160 160-71.766 160-160 160z"
  }));
};
SearchIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512.005 512.005"
};
var SearchInputMobile = exports.SearchInputMobile = function SearchInputMobile(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder;
  var iconUrl = encodeURIComponent(_server["default"].renderToString( /*#__PURE__*/_react["default"].createElement(SearchIcon, null)));
  return /*#__PURE__*/_react["default"].createElement(StyledInput, {
    iconUrl: iconUrl,
    type: "text",
    value: value,
    onChange: onChange,
    placeholder: placeholder
  });
};
var StyledInput = _styledComponents["default"].input.withConfig({
  displayName: "SearchInputmobile__StyledInput",
  componentId: "sc-191b9u5-0"
})(["position:fixed;font-size:18px;line-height:20px;box-sizing:border-box;width:calc(100% - 16px);height:48px;padding-left:30px;padding-right:8px;border:1px solid #c2c5cc;border-radius:4px;background:#ffffff;background-position-x:8px;background-position-y:center;background-size:16px;background-repeat:no-repeat;background-image:url(data:image/svg+xml;charset=UTF-8,", ");::placeholder{color:#c2c5cc;font-size:16px;}"], function (_ref2) {
  var iconUrl = _ref2.iconUrl;
  return iconUrl;
});